import { wymsFetch, getParams } from '@/utils/fetch';

// 获取学校权限树结构
export function permissTree(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schooPermissionManager/permissTree',
        method: 'GET',
        params
    });
}

// 根据pid获取权限子集
export function listPermByPid(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    params.append('pid', args.pid);

    return wymsFetch({
        url: 'schooPermissionManager/listPermByPid',
        method: 'GET',
        params
    });
}

// 获取学校id,权限id获取详情
export function getpermiss(args) {
    const params = getParams();
    params.append('schoolId', args.schoolId);
    params.append('id', args.id);

    return wymsFetch({
        url: 'schooPermissionManager/getpermiss',
        method: 'GET',
        params
    });
}

// 修改学校权限页面显示名称
export function schooPermissionManagerUpdate(args) {
    const params = getParams();
    params.append('description', args.description);
    params.append('permissionId', args.permissionId);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schooPermissionManager/update',
        method: 'GET',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/schoolPermission.js